<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <group-keep-alive>
        <router-view v-if="reload" :key="key" />
      </group-keep-alive>
    </transition>
  </section>
</template>

<script>
import groupKeepAlive from './group-keep-alive.js'

export default {
  name: 'GroupKeepAlive',
  components: { groupKeepAlive },
  data() {
    return {
      reload: true
    }
  },
  computed: {
    key() {
      return `${this.groupIndex}/${this.$route.path}`
    },
    compNames() {
      return this.$store.state.app.groupArray
    },
    visitedViews() {
      return (this.$store.state.app.groupArray[this.groupIndex] || []).filter(item => !item.meta || !item.meta.noCache).map(item => `${this.groupIndex}/${item.compName}`)
    },
    groupIndex() {
      return this.$store.state.app.groupIndex
    },
    groupArray() {
      return this.$store.state.app.groupArray
    }
  },
  methods: {
    handelReloadPage() {
      this.reload = false
      this.$nextTick(() => {
        this.reload = true
      })
    }
  }
}
</script>
<style scoped>
.app-main {
  position: relative;
  min-height: calc(100vh - 62px);
  background-color: #EFF1F8;
  overflow: hidden;
}
</style>
